import React, { useMemo } from "react";
import PropTypes from "prop-types";
import classes from "./StudentEndSidebarProgress.scss";

const StudentEndSidebarProgress = ({ value, total, size, strokeWidth }) => {
  const { radius, circumference, dashOffset } = useMemo(() => {
    const r = (size - strokeWidth) / 2;
    const c = 2 * Math.PI * r;
    const progress = total > 0 ? Math.min(Math.max(value / total, 0), 1) : 0;
    return {
      radius: r,
      circumference: c,
      dashOffset: c * (1 - progress),
    };
  }, [size, strokeWidth, total, value]);

  const center = size / 2;

  return (
    <svg
      className={classes.progress}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={`Progress ${value} of ${total}`}
    >
      <circle
        className={classes.track}
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        strokeWidth={strokeWidth}
      />
      <circle
        className={classes.indicator}
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={dashOffset}
        transform={`rotate(90 ${center} ${center}) scale(-1 1) translate(-${size} 0)`}
        strokeLinecap="round"
      />
    </svg>
  );
};

StudentEndSidebarProgress.propTypes = {
  value: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
};

StudentEndSidebarProgress.defaultProps = {
  size: 28,
  strokeWidth: 4,
};

export default StudentEndSidebarProgress;
